/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import IconEye from '@zvuk-b2b/react-uikit/ui/icons/Eye';

import VideoMediafilePosterContent from './PosterContent';
import styles from './index.module.scss';
import { VideoMediafilePreview } from './VideoMediafilePreview';
import { TEXTS } from './texts';
import { DATA_TEST_IDS } from './consts';
import { OpenPreviewResource, VideoMediafilePosterProps } from './types';

const VideoMediafilePoster: React.FC<VideoMediafilePosterProps> = ({
  link,
  title,
  uploading,
  duration,
  extension,
  url,
  isVideo,

  withPreview = false,
  containerClassName,
  posterClassName,
}) => {
  const [openResource, setOpenResource] = useState<OpenPreviewResource>();
  const canPreview = withPreview && !uploading && Boolean(url) && typeof isVideo === 'boolean';
  const isPreviewOpen = canPreview && openResource?.url === url && openResource?.isVideo === isVideo;

  const onClose = () => setOpenResource(undefined);
  const onOpen = () => {
    if (canPreview && url) setOpenResource({ url, isVideo });
  };

  useEffect(() => {
    setOpenResource(undefined);
  }, [url, isVideo, canPreview]);

  return (
    <div
      data-testid={DATA_TEST_IDS.POSTER}
      onClick={!isPreviewOpen ? onOpen : undefined}
      className={`${styles.container}${containerClassName ? ` ${containerClassName}` : ''} ${canPreview && styles.withPreview}`}>
      <VideoMediafilePosterContent
        link={link}
        title={title}
        uploading={uploading}
        className={posterClassName}
      />
      {duration && (
        <div className={styles.duration}>{DateUtils.msToHMS(duration, ['hours', 'minutes', 'seconds'])}</div>
      )}
      {extension && (
        <div
          className={styles.extension}
          data-testid={DATA_TEST_IDS.EXTENSION}>
          {extension}
        </div>
      )}
      <div
        data-testid={DATA_TEST_IDS.TRIGGER}
        onClick={onOpen}
        className={styles.preview}>
        <IconEye />

        <span>{TEXTS.PREVIEW}</span>
      </div>
      {isPreviewOpen && url && (
        <VideoMediafilePreview
          isVideo={isVideo === true}
          url={url}
          onClose={onClose}
        />
      )}
    </div>
  );
};
export default VideoMediafilePoster;
